export const env = {
    frontendVersion: "V1.2.2-287-g326d14a",
    branch: "dev",
    apiUrl: "https://dev.panda.luminator.com",
    azureClientId: "16bdb26c-3fa3-4549-8702-b9b290810e9c",
    azureAuthority: "https://login.microsoftonline.com/ltgemea.onmicrosoft.com",
}
